import { Wallet, Plus, ArrowDownToLine } from "lucide-react";

export default function WalletCard({ balance, onAddMoney }) {
  return (
    <div className="bg-gradient-to-br from-[#1e1b4b] via-[#4338ca] to-[#7c3aed] text-white rounded-2xl p-6 sm:p-8">
      <div className="flex items-center justify-between flex-wrap gap-4 mb-6">
        <div className="flex items-center gap-3">
          <div className="w-11 h-11 rounded-xl bg-white/15 flex items-center justify-center shrink-0">
            <Wallet className="w-5 h-5" />
          </div>
          <div>
            <p className="text-sm text-indigo-100">ProtoHub Wallet Balance</p>
            <p className="text-3xl sm:text-4xl font-extrabold">
              ₹{balance.toLocaleString("en-IN")}
            </p>
          </div>
        </div>

        <button
          onClick={onAddMoney}
          className="flex items-center gap-2 bg-white text-indigo-700 font-semibold text-sm px-5 py-2.5 rounded-xl hover:bg-gray-100 transition"
        >
          <Plus className="w-4 h-4" /> Add Money
        </button>
      </div>

      <div className="flex items-center gap-2 text-xs text-indigo-100 bg-white/10 rounded-xl px-4 py-2.5 w-fit">
        <ArrowDownToLine className="w-3.5 h-3.5" />
        Use wallet balance to pay quotations instantly, no repeated checkout.
      </div>
    </div>
  );
}